import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Landing } from "./pages/landing";
import { StoreLocator } from "./pages/store-locator";
import { OurWines } from "./pages/our-wines";
import { Story } from "./pages/story";
import { initializeSegment } from "./utils/segment";
import { useEffect } from "react";
import { Community } from "./pages/community";
import { PrivacyTerms } from "./pages/privacy-terms";

export function AppRouter() {
  useEffect(() => {
    initializeSegment();
  }, []);

  return (
    <div className="ambile-container">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/where-to-buy" element={<StoreLocator />} />
          <Route path="/our-wines" element={<OurWines />} />
          <Route path="/story" element={<Story />} />
          <Route path="/community" element={<Community />} />
          <Route path="/privacy-terms" element={<PrivacyTerms />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
